import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';
import { TeamBApi, type Plant } from '@ai-tiaozs/shared';
import { PlantListSection } from '@/components/PlantList';
import { TEAM_B_STEPS } from '@/constants/steps';

/**
 * B 队 · 叶子在说话 首页(我的植物 + 作品流程入口)
 */
export function TeamBHome() {
  const [plants, setPlants] = useState<Plant[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    TeamBApi.listPlants()
      .then((d) => setPlants(d.plants))
      .catch(() => setPlants([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5">
      <header className="card flex items-center gap-3">
        <Leaf className="h-8 w-8 text-teamB-primary" />
        <div>
          <h1 className="font-bold">🌱 家庭植物养护助手</h1>
          <p className="text-xs text-slate-500">拍照 · AI 识别 · 健康跟踪 · 王晟骅 · 易陈 · 华睿</p>
        </div>
      </header>

      <section className="card">
        <h2 className="text-sm font-semibold text-slate-700">作品流程</h2>
        <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
          {TEAM_B_STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.id}
                to={s.path}
                className="card flex flex-col items-center gap-1 p-3 text-center hover:shadow-md"
              >
                <span className="badge bg-teamB-primary/10 text-teamB-primary">第 {idx + 1} 步</span>
                <Icon className="h-5 w-5 text-teamB-primary" />
                <span className="text-sm font-medium">{s.name}</span>
                <span className="text-[11px] leading-tight text-slate-500">{s.desc}</span>
                <span className="text-[10px] text-slate-400">责任:{s.owner}</span>
              </Link>
            );
          })}
        </div>
        <div className="mt-2 text-center">
          <Link to="/report" className="text-xs text-teamB-primary underline">
            📊 查看家庭植物健康报告 →
          </Link>
        </div>
      </section>

      <PlantListSection
        plants={plants}
        loading={loading}
        showAddButton
        showEmptyAddLink
      />
    </div>
  );
}
